var _excluded = ["children", "color", "customStyle", "disabled", "flippable", "focusable", "quietArea", "size", "src", "title", "viewBox"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { useTheme } from '@veneer/theme';
import useDirection from '../direction/use_direction';
import useStyles from './use_styles';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CustomImage = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      color,
      customStyle: customStyleProp,
      disabled = false,
      flippable = false,
      focusable = false,
      quietArea = 0,
      size = 24,
      src,
      title,
      viewBox = '0 0 24 24'
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  var {
    isRTL
  } = useDirection();
  var theme = useTheme();
  var {
    density,
    mode,
    shape
  } = theme;
  var themeVars = {
    shape,
    density,
    mode,
    theme
  };
  var customStyle = typeof customStyleProp === 'function' ? customStyleProp(themeVars) : customStyleProp;
  var style = useStyles({
    color,
    disabled,
    flippable,
    isRTL,
    isSvg: !src,
    quietArea,
    size
  });
  var imgProps = _objectSpread({
    'aria-hidden': title && !disabled ? undefined : true,
    'aria-label': title,
    css: [style, customStyle]
  }, other);
  return src ? ___EmotionJSX("img", _extends({
    alt: title,
    src: src
  }, imgProps, {
    ref: ref
  })) : ___EmotionJSX("svg", _extends({
    fill: "currentColor",
    focusable: focusable,
    role: title ? 'img' : undefined,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg"
  }, imgProps, {
    ref: ref
  }), typeof children === 'function' ? children(themeVars) : children);
});
CustomImage.propTypes = propTypes;
CustomImage.displayName = 'CustomImage';
export default CustomImage;